import React, { useEffect, useState, Component } from "react";
import {
  Container,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import Select from "react-select";
import { Table, Row, Col, Card, CardBody, Modal } from "reactstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Pagi2 from "common/utils/Pagi2";
import "../../common/styles/invoice.css";
import {
  colourStyles,
  customerOptions,
  projects,
} from "common/utils/ComonOptions";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import paymentHistoryImg from "../../assets/images/paymentHistory.jpg";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import configure from "configure";
import moment from "moment";
import ViewZithasTechInvoice from "./ViewZithasTechInvoice";
import { Link } from "react-router-dom";
import Pagination from "common/utils/Pagination";

// Error Boundary Component
class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <h1 className="text-danger text-center">
          Something went wrong with the table.
        </h1>
      );
    }
    return this.props.children;
  }
}

function TableContainer({
  columns,
  data = [],
  allData,
  setData,
  setAccessDenied,
  customerOptions,
  setCustomerOptions,
}) {
  const [fixedContent, setFixedContent] = useState(false);
  const [formPopup, setFormPopup] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [title, setTitle] = useState("");
  const [nameModal, setNameModal] = useState(false);

  // Calculate amounts in INR
  const calculateAmountsInINR = (invoices) => {
    return invoices.reduce(
      (acc, item) => {
        if (item.trash !== 0) return acc; // Skip trashed invoices
        const exchangeRate = parseFloat(item.exchange_rate) || 1;
        const isINR = item.currency_symbol === "₹";
        const total = parseFloat(item.total) || 0;
        const dueAmount = parseFloat(item.balance_due) || 0;
        const totalINR = isINR ? total : total * exchangeRate;
        const dueAmountINR = isINR ? dueAmount : dueAmount * exchangeRate;
        return {
          totalAmount: acc.totalAmount + totalINR,
          dueAmount: acc.dueAmount + dueAmountINR,
        };
      },
      { totalAmount: 0, dueAmount: 0 }
    );
  };

  // Apply client-side filtering
  const applyFilters = () => {
    let filteredData = [...allData];

    // Filter by date range
    if (startDate && endDate) {
      filteredData = filteredData.filter((item) => {
        const invoiceDate = moment(item.invoice_date, "YYYY-MM-DD");
        return (
          invoiceDate.isSameOrAfter(moment(startDate, "YYYY-MM-DD")) &&
          invoiceDate.isSameOrBefore(moment(endDate, "YYYY-MM-DD"))
        );
      });
    } else if (startDate) {
      filteredData = filteredData.filter((item) => {
        const invoiceDate = moment(item.invoice_date, "YYYY-MM-DD");
        return invoiceDate.isSameOrAfter(moment(startDate, "YYYY-MM-DD"));
      });
    } else if (endDate) {
      filteredData = filteredData.filter((item) => {
        const invoiceDate = moment(item.invoice_date, "YYYY-MM-DD");
        return invoiceDate.isSameOrBefore(moment(endDate, "YYYY-MM-DD"));
      });
    }

    // Filter by customer
    if (selectedCustomer) {
      filteredData = filteredData.filter(
        (item) => item.customer_id === selectedCustomer.value
      );
    }

    setData(filteredData);
  };

  // Calculate totals using allData (unfiltered)
  const { totalAmount, dueAmount } = calculateAmountsInINR(allData);
  const receivedAmount = totalAmount - dueAmount;

  useEffect(() => {
    const handleScroll = () => {
      setFixedContent(window.scrollY > 165);
    };
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.88);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => setPageSize(10), []);

  return (
    <div>
      <Row className="d-flex mt-4">
        <div className="d-flex col-md-8 justify-flex-start align-items-center gap-2">
          <div className="col-4 invoice_status text-info pt-2 px-1 rounded text-center">
            <h6>Total Invoice Amount</h6>
            <h3>₹ {totalAmount?.toLocaleString("en-IN")}</h3>
          </div>
          <div className="col-4 invoice_status text-success pt-2 px-0 rounded text-center">
            <h6>Total Received Amount</h6>
            <h3>₹ {receivedAmount?.toLocaleString("en-IN")}</h3>
          </div>
          <div className="col-4 invoice_status text-danger pt-2 px-2 rounded text-center">
            <h6>Total Due Amount</h6>
            <h3>₹ {dueAmount?.toLocaleString("en-IN")}</h3>
          </div>
        </div>
        <div className="col-md-4 text-end"></div>
      </Row>
      <Row className="m-0 d-flex justify-content-between align-items-center">
        <div className="p-0 col-2">
          <select
            className="form-select mt-3"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
        <div className="p-0 col-4 d-flex justify-content-end align-items-center gap-3">
          <div className="search-box my-xxl-0 d-inline-block">
            <div className="position-relative mt-4">
              <label htmlFor="search-bar-0" className="search-label">
                <span id="search-bar-0-label" className="sr-only">
                  Search this table
                </span>
                <input
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  id="search-bar-0"
                  type="text"
                  className="form-control rounded h-100"
                  placeholder="Search..."
                  value={globalFilter || ""}
                />
              </label>
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>
          {/* <button
            type="button"
            className="btn btn-outline-secondary mt-3"
            onClick={() => setFormPopup(true)}
          >
            <i className="fas fa-filter"></i>
          </button> */}
        </div>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fix-header" : ""
              } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className || ""}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true);
                          setTitle(column.Header);
                        }}
                      >
                        {/* <i title="info" className="bx bx-info-circle ms-1 info-icon"></i> */}
                      </a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr className="row-hover" {...row.getRowProps()} key={i}>
                    {row.cells.map((cell, index) => (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className || ""
                          }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No invoices found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
      {formPopup ? (
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "30%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <Form
              className="row d-flex justify-content-start align-items-center"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="col-9 d-flex">
                <div className="ps-2">
                  <Label htmlFor="formrow-start-date">
                    Start Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    id="formrow-start-date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="ps-2">
                  <Label htmlFor="formrow-end-date">
                    End Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    id="formrow-end-date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="col-4 ps-2">
                  <Label htmlFor="formrow-customer">
                    Customer <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="- Select Customer -"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={customerOptions}
                    styles={colourStyles}
                    value={selectedCustomer}
                    onChange={(selected) => setSelectedCustomer(selected)}
                  />
                </div>
              </div>
              <div className="col-3 mt-4 d-flex justify-content-end align-items-end gap-2">
                <button
                  type="button"
                  className="btn btn-save btn-label me-1"
                  onClick={(e) => {
                    e.preventDefault();
                    applyFilters();
                  }}
                >
                  <i className="fas fa-filter search-icon label-icon"></i>{" "}
                  Filter
                </button>
                <button
                  type="button"
                  className="btn btn-red btn-label me-1"
                  onClick={() => {
                    setStartDate("");
                    setEndDate("");
                    setSelectedCustomer(null);
                    setData(allData);
                    setFormPopup(false);
                  }}
                >
                  <i className="dripicons-cross label-icon"></i> Close
                </button>
              </div>
            </Form>
          </ResizableBox>
        </Draggable>
      ) : null}
    </div>
  );
}

const Zithasinvoice = () => {
  const [viewModal, setViewModal] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]); // Store full API response
  const [error, setError] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [modal_Access, setAccessDenied] = useState(false);
  const [customerOptions, setCustomerOptions] = useState([]); // Manage customer options

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setViewModal(false);
        setPaymentHistory(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  document.title = "Zithas TAX Invoice | Zithas Crm";

  useEffect(() => {
    fetchContract();
  }, []);

  const fetchContract = async () => {
    setLoading(true);
    setError(null);
    const authUser = secureLocalStorage.getItem("Token");
    const userData = secureLocalStorage.getItem("User");
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/introducerInvoice/${userData.id}`,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      });
      const invoices = Array.isArray(response.data)
        ? response.data
        : response.data.data || [];
      setAllData(invoices);
      setData(invoices);

      const uniqueCustomers = Array.from(
        new Map(
          invoices.map((item) => [
            item.customer_id,
            {
              value: item.customer_id,
              label: item.c_company || item.name || "Unknown",
            },
          ])
        ).values()
      ).sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically
      setCustomerOptions(uniqueCustomers);

      setLoading(false);
    } catch (error) {
      console.error("fetchContract Error:", error);
      setError("Failed to fetch invoices. Please try again.");
      setAllData([]);
      setData([]);
      setCustomerOptions([]);
      setLoading(false);
    }
  };

  const onPaymentRecord = (row) => {
    console.log("Payment Record for:", row);
    setPaymentHistory(true);
  };

  const onVoid = async (id, isVoid) => {
    try {
      const authUser = secureLocalStorage.getItem("Token");
      const userData = secureLocalStorage.getItem("User");
      await axios({
        method: "get",
        url: `${configure.apiUrl}/introducerInvoice/void/${userData.id}`,
        headers: { Authorization: `Bearer ${authUser}` },
      });
      Swal.fire({
        title: isVoid ? "Invoice Unvoided" : "Invoice Voided",
        icon: "success",
        timer: 1500,
      });
      fetchContract();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Failed to update invoice status.",
        icon: "error",
      });
    }
  };

  const onDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      try {
        const authUser = secureLocalStorage.getItem("Token");
        const userData = secureLocalStorage.getItem("User");
        await axios({
          method: "delete",
          url: `${configure.apiUrl}/introducerInvoice/${userData.id}`,
          headers: { Authorization: `Bearer ${authUser}` },
        });
        Swal.fire({
          title: "Deleted!",
          text: "Invoice has been deleted.",
          icon: "success",
          timer: 1500,
        });
        fetchContract();
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "Failed to delete invoice.",
          icon: "error",
        });
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Sr.No",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center sr-col",
      },
      {
        Header: "Date",
        accessor: "invoice_date",
        isInfoIcon: false,
        className: "text-center date-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.invoice_date
              ? moment(row.original.invoice_date).format("DD-MM-YYYY")
              : "-"}
          </div>
        ),
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Invoice</div>,
        accessor: "tax_inv_no",
        grow: false,
        className: "invoice_box text-center",
        isInfoIcon: true,
        Cell: ({ value, row }) => (
          <div>{value || row.original?.invoice_number || "-"}</div>
        ),
      },
      {
        Header: "Customer",
        accessor: "c_company",
        isInfoIcon: true,
        className: "customer-col",
        Cell: ({ value }) => <div>{value || "-"}</div>,
      },
      {
        Header: "Due Date",
        accessor: "due_date",
        isInfoIcon: false,
        className: "text-center due_date-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.due_date
              ? moment(row.original.due_date).format("DD-MM-YYYY")
              : "-"}
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: "total",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.currency_symbol || "₹"}{" "}
            {Number(row.original?.total || 0).toFixed(2)}
          </div>
        ),
      },
      {
        Header: "Balance Due",
        accessor: "balance_due",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.balance_due <= "0" ? (
              <h4>
                <span className="badge bg-success font-size-12">
                  Fully Paid
                </span>
              </h4>
            ) : (
              <div>
                {row.original?.currency_symbol || "₹"}{" "}
                {Number(row.original?.balance_due || 0).toFixed(2)}
              </div>
            )}
          </div>
        ),
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Action</div>,
        accessor: "action",
        className: "text-center action-col",
        Cell: ({ row }) => {
          const type = "ztpl";
          return (
            <div className="d-flex justify-content-center">
              <Link
                to={`${configure.appUrl}/finance/view/${type}/${row.original?.id}`}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="View Invoice"
                onClick={() => setSelectedInvoice(row.original)}
              >
                <i className="fas fa-eye"></i>
              </Link>
            </div>
          );
        },
      },
    ],
    [onPaymentRecord, onVoid, onDelete]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="ZTPL Invoice" />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center">Loading invoices...</div>
                  ) : error ? (
                    <div className="text-danger text-center">{error}</div>
                  ) : (
                    <ErrorBoundary>
                      <div className="responsive-table">
                        <TableContainer
                          columns={columns}
                          data={data}
                          allData={allData}
                          setData={setData}
                          setAccessDenied={setAccessDenied}
                          customerOptions={customerOptions}
                          setCustomerOptions={setCustomerOptions}
                        />
                      </div>
                    </ErrorBoundary>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* View Modal */}
      <Modal size="xl" isOpen={viewModal} className="modal-fullscreen">
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <div className="col-6 d-flex align-items-center">
              <h5 className="modal-title mt-0">View Zithas Invoice</h5>
            </div>
            <div className="col-6 text-end">
              <button className="btn ms-md-2 btn-save btn-label">
                <i className="fas fa-save me-1 label-icon"></i> Save
              </button>
              <button
                className="btn ms-md-2 btn-red btn-label"
                onClick={() => setViewModal(false)}
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>{" "}
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
          <div className="mb-3" style={{ padding: "0 11px 0 12px" }}>
            <Form>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-2 mb-3">
                  <label htmlFor="location">Location</label>
                  <input
                    className="form-control"
                    value={selectedInvoice?.c_location || "India"}
                    disabled
                    id="location"
                  />
                </div>
                <div className="col-md-4 mb-3 mb-md-0">
                  <label htmlFor="customer-name">
                    Customer Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    value={selectedInvoice?.c_company || ""}
                    disabled
                    id="customer-name"
                  />
                </div>
                <div className="col-4 mb-3 mb-md-0">
                  <label htmlFor="project">Project</label>
                  <input
                    className="form-control"
                    value={selectedInvoice?.project || "N/A"}
                    disabled
                    id="project"
                  />
                </div>
              </Row>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-md-3 mb-3">
                  <label htmlFor="invoice-number">
                    Invoice Number <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled
                    type="text"
                    name="invoice_number"
                    value={selectedInvoice?.invoice_number || ""}
                    placeholder="Invoice Number"
                    className="form-control"
                    id="invoice-number"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="invoice-date">
                    Invoice Date <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled
                    type="date"
                    name="invoice_date"
                    value={
                      selectedInvoice?.invoice_date
                        ? moment(selectedInvoice.invoice_date).format(
                          "YYYY-MM-DD"
                        )
                        : ""
                    }
                    placeholder="Invoice Date"
                    className="form-control"
                    id="invoice-date"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="terms">
                    Terms <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    value={selectedInvoice?.terms || ""}
                    placeholder="Terms"
                    disabled
                    id="terms"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="due-date">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled
                    type="date"
                    name="due_date"
                    value={
                      selectedInvoice?.due_date
                        ? moment(selectedInvoice.due_date).format("YYYY-MM-DD")
                        : ""
                    }
                    placeholder="Select Due Date"
                    className="form-control"
                    id="due-date"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="start-date">Start Date</label>
                  <input
                    disabled
                    type="date"
                    name="start_date"
                    value={
                      selectedInvoice?.start_date
                        ? moment(selectedInvoice.start_date).format(
                          "YYYY-MM-DD"
                        )
                        : ""
                    }
                    placeholder="Select Start Date"
                    className="form-control"
                    id="start-date"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="end-date">End Date</label>
                  <input
                    disabled
                    type="date"
                    name="end_date"
                    value={
                      selectedInvoice?.end_date
                        ? moment(selectedInvoice.end_date).format("YYYY-MM-DD")
                        : ""
                    }
                    placeholder="Select End Date"
                    className="form-control"
                    id="end-date"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="currency">Currency</label>
                  <input
                    className="form-control"
                    value={selectedInvoice?.currency_symbol || "₹"}
                    disabled
                    id="currency"
                  />
                </div>
              </Row>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5>Service Details</h5>
                </div>
                <div className="col-md-12">
                  <Table bordered hover responsive size="" striped>
                    <thead>
                      <tr>
                        <th className="text-center sid-col-1">ID</th>
                        <th className="service-col-2">SERVICE DETAILS</th>
                        <th className="hsn-col-3 text-center">HSN</th>
                        <th className="qty-col-4 text-center">QUANTITY</th>
                        <th className="text-center rate-col-5">RATE</th>
                        <th className="text-center tax-col-5">TAX</th>
                        <th className="text-center amt-col-5">AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedInvoice?.items?.length > 0 ? (
                        selectedInvoice.items.map((item, index) => (
                          <tr key={item.id}>
                            <td scope="row" className="text-center id-col-1">
                              {index + 1}
                            </td>
                            <td className="service-col-2">
                              <input
                                disabled
                                type="text"
                                className="form-control"
                                value={
                                  item.service_detail || item.service || "N/A"
                                }
                              />
                            </td>
                            <td className="hsn-col-3 text-center">
                              <input
                                className="form-control"
                                value={item.hsn || "N/A"}
                                disabled
                              />
                            </td>
                            <td className="bill-col-4 qty-center">
                              <input
                                disabled
                                type="text"
                                className="form-control"
                                value={item.quantity || 0}
                              />
                            </td>
                            <td className="text-center rate-col-5">
                              <input
                                disabled
                                type="text"
                                className="form-control"
                                value={Number(item.rate || 0).toFixed(2)}
                              />
                            </td>
                            <td className="text-center tax-col-5">
                              <h5>{item.tax || "0%"}</h5>
                            </td>
                            <td className="text-center amt-col-5">
                              <h5>{Number(item.amount || 0).toFixed(2)}</h5>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No items available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Row>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-7 edit-descrip" id="ckeEditor">
                  <div className="d-flex justify-space-between">
                    <label htmlFor="customer-notes">
                      Customer Notes <span className="text-danger">*</span>
                    </label>
                  </div>
                  <CKEditor
                    editor={ClassicEditor}
                    disabled={true}
                    className="ckeEditor"
                    data={
                      selectedInvoice?.customer_note || "No notes available"
                    }
                  />
                </div>
                <div className="col-5 checkout-box py-5 px-5">
                  <div className="col-12 gap-3 mb-3 d-flex justify-space-between">
                    <h5>Sub Total -</h5>
                    <h5>
                      ({selectedInvoice?.currency_symbol || "₹"}){" "}
                      {Number(selectedInvoice?.sub_total || 0).toFixed(2)}
                    </h5>
                  </div>
                  <div className="col-12 mb-3 d-flex justify-space-between">
                    <div className="col-6 d-flex gap-5">
                      <div className="d-flex flex-column col-md-8">
                        <label htmlFor="discount-type">Select Discount</label>
                        <input
                          className="form-control"
                          value={selectedInvoice?.discount_type || "N/A"}
                          disabled
                          id="discount-type"
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="mb-0">Discount Amount</label>
                        <input
                          disabled
                          type="text"
                          name="discount"
                          value={Number(
                            selectedInvoice?.discount_amount || 0
                          ).toFixed(2)}
                          className="form-control text-center mt-2"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="tax-box">
                    <div className="col-12 mb-3 mt-4">
                      <h5>Tax</h5>
                    </div>
                    {selectedInvoice?.cgst ? (
                      <div className="col-12 gap-3 mb-3 d-flex justify-space-between text-muted">
                        <h6>CGST (9%)</h6>
                        <h5>{Number(selectedInvoice.cgst).toFixed(2)}</h5>
                      </div>
                    ) : null}
                    {selectedInvoice?.sgst ? (
                      <div className="col-12 gap-3 mb-3 d-flex justify-space-between text-muted">
                        <h6>SGST (9%)</h6>
                        <h5>{Number(selectedInvoice.sgst).toFixed(2)}</h5>
                      </div>
                    ) : null}
                    {selectedInvoice?.igst ? (
                      <div className="col-12 gap-3 mb-3 d-flex justify-space-between text-muted">
                        <h6>IGST (18%)</h6>
                        <h5>{Number(selectedInvoice.igst).toFixed(2)}</h5>
                      </div>
                    ) : null}
                    <div className="col-12 gap-3 mb-3 d-flex justify-content-center gap-3">
                      <h5>Total ({selectedInvoice?.currency_symbol || "₹"})</h5>
                      <h5>{Number(selectedInvoice?.total || 0).toFixed(2)}</h5>
                    </div>
                  </div>
                </div>
              </Row>
            </Form>
          </div>
        </div>
      </Modal>

      {/* Payment History Modal */}
      <Modal isOpen={paymentHistory} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Payment History</h5>
          <button
            type="button"
            onClick={() => setPaymentHistory(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body pe-4 my-5">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img
                  src={paymentHistoryImg}
                  alt="Payment History"
                  style={{ width: "80%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default Zithasinvoice;